import React from 'react';
//import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Register from './components/Register';
import QuizList from './components/QuizList';
import QuizEditor from './components/QuizEditor';
import QuizAttempt from './components/QuizAttempt';
import QuizResults from './components/QuizResults';
import StudyCircleList from './components/StudyCircleList';
import StudyCircleDetails from './components/StudyCircleDetails';
import Navbar from './components/Navbar';
import QuizAttemptsList from './components/QuizAttemptsList';
import QuizzesManager from './components/QuizzesManager';
import Footer from './components/Footer';

// Protected Route Component
const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { user, isAuthenticated } = useAuth();
    
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (requireAdmin && user?.role !== 'admin') {
        return <Navigate to="/quizzes" replace />;
    }

    return children;
};

const QuizzesRoute = () => {
    const { user } = useAuth();
    if (!user) return null;
    if (user.role === 'admin') {
        return <QuizzesManager />;
    } else {
        return <QuizList />;
    }
};

const App = () => {
    return (
        <Router>
            <AuthProvider>
                <div className="app">
                    <Navbar />
                    <div className="container mt-4">
                        <Routes>
                            {/* Public Routes */}
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />

                            {/* Protected Routes */}
                            <Route
                                path="/quizzes"
                                element={
                                    <ProtectedRoute>
                                        <QuizzesRoute />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/quiz-editor/:id?"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <QuizEditor />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/quiz-editor/new/:studyCircleId?/:folderId?"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <QuizEditor />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/quiz/:id/attempt"
                                element={
                                    <ProtectedRoute>
                                        <QuizAttempt />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/quiz/:id/results"
                                element={
                                    <ProtectedRoute>
                                        <QuizResults />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/study-circles"
                                element={
                                    <ProtectedRoute>
                                        <StudyCircleList />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/study-circles/:id"
                                element={
                                    <ProtectedRoute>
                                        <StudyCircleDetails />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Admin routes */}
                            <Route
                                path="/quiz-attempts"
                                element={
                                    <ProtectedRoute requireAdmin>
                                        <QuizAttemptsList />
                                    </ProtectedRoute>
                                }
                            />

                            {/* Default Routes */}
                            <Route path="/" element={<Navigate to="/quizzes" replace />} />
                            <Route path="*" element={<Navigate to="/quizzes" replace />} />
                        </Routes>
                    </div>
                    <Footer />
                </div>
            </AuthProvider>
        </Router>
    );
};

export default App; 